"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var itemStyles = styles_1.makeStyles(function (_a) {
    var _b;
    var palette = _a.palette, breakpoints = _a.breakpoints;
    return ({
        itemWrapper: {
            marginBottom: '40px',
        },
        item: (_b = {
                border: "1px solid " + palette.grey['300'],
                display: 'flex',
                height: '100%',
                flexDirection: 'column',
                justifyContent: 'space-between'
            },
            _b[breakpoints.down('sm')] = {
                height: 'fit-content',
            },
            _b),
        itemSelected: {
            borderColor: palette.primary.main,
        },
    });
}, { name: 'GqlCheckout_ExpressionsOfInterest_Item' });
exports.default = itemStyles;
